import { AtendimentoType, VinculoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type GestaoAtendimentosFilters = {
  paciente: string
  protocolo: string
  /** Período: campo de data ("Consultas entre") + início/fim (aaaa-mm-dd), máx. 31 dias. */
  range?: IOption<string>
  inicio: string
  fim: string
  empresa?: IOption<number>
  /** Depende da instituição (é limpa quando a instituição sai). */
  unidade?: IOption<number>
  especialidade?: IOption<number>
  retorno?: IOption<boolean>
  tipoAtendimento?: IOption<AtendimentoType>
  vinculo?: IOption<VinculoType>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<GestaoAtendimentosFilters>(
  {
    paciente: '',
    protocolo: '',
    range: undefined,
    inicio: '',
    fim: '',
    empresa: undefined,
    unidade: undefined,
    especialidade: undefined,
    retorno: undefined,
    tipoAtendimento: undefined,
    vinculo: undefined,
  }
)
